import { render, staticRenderFns } from "./VipPageCreateModalComponent.vue?vue&type=template&id=0f2f530c&scoped=true"
import script from "./VipPageCreateModalComponent.vue?vue&type=script&lang=js"
export * from "./VipPageCreateModalComponent.vue?vue&type=script&lang=js"
import style0 from "./VipPageCreateModalComponent.vue?vue&type=style&index=0&id=0f2f530c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2f530c",
  null
  
)

export default component.exports